<template>
    <div :class="$style.wrapper">
        <span @click.stop="visible=true">
            <slot></slot>
        </span>
        <el-dialog
            :visible.sync="visible"
            :append-to-body="true"
            :custom-class="'yx-popover'"
            :title="title || '标题'"
        >
            <slot name="content"></slot>
            <div class="yx-popover-btnGroup">
                <el-button :loading="btnLoading" :class="['orangeBtn', 'yx-popover-btn']"  @click="handleConfirm">{{confirmText||'确认'}}</el-button>
                <el-button :class="['btn', 'yx-popover-btn', 'yx-popover-cancelBtn']" @click="visible=false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { handleSubmit, session_id } from '../../stores/api';
    export default {
        props: ['title', 'confirmText', 'handleSubmit','name','positionId','phone','password'],
        data () {
            return {
                visible: false,
                btnLoading: false,
            };
        },
        methods: {
            async handleConfirm() {
                this.btnLoading = true;
                this.$http.get(this.$reqUrl+'user.php?act=update_staff&commission='+''+'&mobile='+this.phone+'&password='+this.password+'&position_id='+this.positionId+'&session_id='+session_id+'&staff_id='+''+'&staff_name='+this.name)
                .then(res=>{
                    console.log(res)
                    if(res.data.error===2){
                         this.$message.error(res.data.msg);
                    }else{
                        this.$router.go({path:'/Management'})
                    }

                })
                // return  handleSubmit().then(res=>{
                //     console.log(res)
                // })
                this.btnLoading = false;
                this.visible = false;
            }
        }
    };
</script>

<style lang="less" module>
    .wrapper {
        display: inline-block;
    }
</style>
<style lang="less">
    .yx-popover {
        width: 500Px;
        .el-dialog__header {
            display: flex;
            justify-content: center;
            border-bottom: 1px solid #C7C7C7;
        }
        .el-dialog__body {
            padding: 30Px 90Px 30Px 70Px;
            text-align: center;
            .yx-popover-btn {
                margin-top: 10PX;
                width:120Px;
                height:35Px;
                font-size:16px;
                color:#ffffff;
                border-radius:4px;
            }
            .yx-popover-cancelBtn {
                margin-left: 10px;
                background:#d8dde6;
            }
            input {
                border-radius: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Common/PopoverForm.vue